<template>
  <div class="reserve home_page">
    <el-form :inline="true"
             :model="dataForm"
             class="demo-form-inline">
      <el-form-item label="地域：">
        <el-select v-model="dataForm.province"
                   placeholder="省"
                   clearable
                   filterable
                   @change="handleProvinceChoose">
          <el-option v-for="(item, index) in provinceList"
                     :key="index"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
        <el-select v-model="dataForm.city"
                   placeholder="市"
                   clearable
                   filterable
                   style="margin-left: 20px;"
                   @change="getHouseList">
          <el-option v-for="(item, index) in cityList"
                     :key="index"
                     :label="item.name"
                     :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库：">
        <el-select v-model="dataForm.storeId"
                   placeholder="全部"
                   clearable
                   @change="getDataList(1)">
          <el-option v-for="(item, index) in storeList"
                     :key="index"
                     :label="item.storeName"
                     :value="item.storeId">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item> -->
    </el-form>
    <div class="search-row">
      <div class="lclb_tabs">
        <div class="lclb_tab_item cursor-pointer"
             @click="handleClickTabs('all')"
             :class="{'tab_item_choosed':activeTab=== 'all'}">全部</div>
        <div class="lclb_tab_item cursor-pointer"
             @click="handleClickTabs('my')"
             :class="{'tab_item_choosed':activeTab=== 'my'}">我的</div>
      </div>
      <!-- <el-tabs v-model="activeTab" @tab-click="handleClickTabs">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="我的" name="my"></el-tab-pane>
      </el-tabs> -->
      <!-- <div class="search-sort">
        <el-button>上架时间</el-button>
        <el-button>价格</el-button>
        <el-button>更新时间</el-button>
      </div> -->
    </div>
    <el-row :gutter="20"
            v-loading="dataListLoading">
      <el-col :span="6"
              v-for="(item, index) in dataList"
              :key="item.skuId"
              v-show="dataList && dataList.length">
        <div class="good_item">
          <div class="item_img cursor-pointer"
               :class="{'item_img_choosed':item.choosed}"
               @click="choosedItem(index)">
            <img :src="item.goodsUrl"
                 width="252px"
                 height="189px" />
          </div>
          <div class="good_name ellipsis">{{activeTab === 'my' ? item.oldGoodsName : item.goodsName}}</div>
          <div class="good_opt">
            <font>({{item.safetyStockQuantity || 0}}次备用)</font>
            <font>({{item.receiveQuantity||0}}次领用)</font>
          </div>
          <div class="good_opt">
            <div v-if="item.price && Number(item.price)">￥<font style="font-size: 24px;"
                    class="color_red">{{item.price | formatterPrice}}</font>
            </div>
            <div v-else><font style="font-size: 20px;"
                    class="color_red">协议价</font>
            </div>
            <el-button @click="spareOneHandle(item)">{{activeTab === 'my'?'领用':'备用'}}</el-button>
          </div>
          <!-- <div class="good_item_choosed cursor-pointer" v-show="item.choosed" @click="choosedItem(index)">
            <div class="triangle">
              <i class="el-icon-check"></i>
            </div>
          </div> -->
        </div>
      </el-col>
      <el-col :span="24"
              v-show="!dataList.length">
        <div class="no_show_message">
          <img src="@/assets/img/good/noGood.png"
               alt="暂无相关商品">
          <!-- <div>暂无相关商品</div> -->
        </div>
      </el-col>
    </el-row>
    <el-row class="statistics">
      <el-col :span="12">
        <el-checkbox v-model="allChecked"
                     @change="changeAllHandle">本页全选</el-checkbox>
      </el-col>
      <el-col :span="5">
        共计：<font class="color_red">{{choosedNum}}</font>件
      </el-col>
      <el-col :span="7">
        <span style="margin-right: 20px;">合计：<font class="color_red">{{allMoney}}</font>元</span>
        <el-button @click="spareHandle"
                   :disabled="!choosedNum">一键{{activeTab === 'my'?'领用':'备用'}}</el-button>
      </el-col>
    </el-row>
    <el-pagination @size-change="sizeChangeHandle"
                   @current-change="getDataList"
                   :current-page="dataForm.page"
                   :page-sizes="[12, 24, 48, 96]"
                   :page-size="dataForm.limit"
                   :total="total"
                   layout="prev, pager, next"
                   style="text-align: center;">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataForm: {
        province: '',
        city: '',
        storeId: '',
        page: 1,
        limit: 12
      },
      provinceList: [],
      cityList: [],
      storeList: [],
      activeTab: 'all',
      dataList: [],
      dataListLoading: false,
      total: 0,
      allChecked: false, // 全选
      getHouseTime: null
    }
  },
  computed: {
    choosedNum () {
      let num = 0
      if (this.dataList.length) {
        num = this.dataList.filter(item => {
          return item.choosed
        }).length
      }
      return num
    },
    allMoney () {
      let money = 0
      if (this.dataList.length) {
        let list = this.dataList.filter(item => {
          return item.choosed
        })
        if (list.length) {
          list.forEach(item => {
            if (item.price && Number(item.price)) {
              money += Number(item.price)
            }
          })
        }
      }
      return money.toFixed(2)
    }
  },
  filters: {
    formatterPrice (value) {
      if (!value || !Number(value)) {
        return '协议价'
      }
      return Number(value).toFixed(2)
    }
  },
  mounted () {
    if (this.$route.query.province) {
      this.dataForm.province = this.$route.query.province
      // this.handleProvinceChoose(this.dataForm.province)
    }
    this.getProvince()
    this.getHouseList()
    this.getDataList(1)
  },
  methods: {
    handleClickTabs (val) {
      this.activeTab = val
      this.getDataList(1)
    },
    getProvince () {
      this.$request.get(`/front/sys/sysProvince/provinceList`)
        .then(data => {
          this.provinceList = data || []
          if (this.$route.query.province) {
            this.handleProvinceChoose(this.dataForm.province)
          }
        })
    },
    handleProvinceChoose (val) {
      this.dataForm.city = ''
      this.cityList = []
      let provice = this.provinceList.find(item => {
        return item.name === val
      })
      this.getHouseList()
      this.getDataList(1)
      if (provice) {
        this.$request.get(`/front/sys/sysProvince/cityList/${provice.codeP}`)
          .then(data => {
            this.cityList = data || []
          })
      }
    },
    // 获取仓库列表
    getHouseList () {
      this.getDataList(1)
      this.dataForm.storeId = ''
      if (this.getHouseTime) {
        clearTimeout(this.getHouseTime)
        this.getHouseTime = null
      }
      let that = this
      this.getHouseTime = setTimeout(function () {
        that.$request.postParam(`/front/order/lclb/storeSet/selectList`, {
          province: that.dataForm.province,
          city: that.dataForm.city
        })
          .then(data => {
            that.storeList = data || []
          })
      }, 2000)
    },
    sizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    // 获取商品列表
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      this.dataListLoading = true
      this.$request.postParam(
        this.activeTab === 'all' ? `/front/order/lclb/home/sparePartsDistribution` : `/front/order/lclb/home/sparePartsDistributionMy`,
        {
          companyId: this.$store.state.user.defaultCompanyId,
          ...this.dataForm
        }
      )
        .then(data => {
          if (data) {
            this.total = data.count || 0
            this.dataList = data.data || []
          } else {
            this.total = 0
            this.dataList = []
          }
        })
        .catch(() => {
          this.total = 0
          this.dataList = []
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 改变选中状态
    choosedItem (index) {
      this.dataList[index].choosed = !this.dataList[index].choosed
      this.$set(this.dataList, index, this.dataList[index])
      let choosedList = this.dataList.filter(item => {
        return item.choosed
      })
      if (choosedList.length === this.dataList.length) {
        this.allChecked = true
      } else {
        this.allChecked = false
      }
    },
    changeAllHandle (val) {
      if (val && this.dataList.length) {
        this.allChecked = true
        this.dataList.forEach((item, index) => {
          if (!item.choosed) {
            item.choosed = true
            this.$set(this.dataList, index, item)
          }
        })
      } else {
        this.allChecked = false
        this.dataList.forEach((item, index) => {
          if (item.choosed) {
            item.choosed = false
            this.$set(this.dataList, index, item)
          }
        })
      }
    },
    // 单独点击备用
    spareOneHandle (item) {
      if (this.activeTab === 'my') {
        let list = [{
          oldGoodsCode: item.oldGoodsCode,
          oldGoodsName: item.oldGoodsName,
          oldSpecification: item.oldSpecification,
          oldModel: item.oldModel,
          oldBrand: item.oldBrand,
          oldRemark: item.oldRemark,
          goodsNum: 0,
          oldEdition: item.oldEdition,
          oldCongiguration: item.oldCongiguration,
          goodsPrice: item.price,
          // safetyStockQuantityBef: 0,
          safetyStockQuantity: item.stockQuantity,
          custspId: item.custspId
        }]
        this.$store.dispatch('setLclbDataList', list)
        this.$router.push({
          name: 'spareGetAdd',
          query: {
            getList: 1
          }
        })
      } else {
        let list = [{
          oldGoodsCode: item.goodsCode,
          oldGoodsName: item.goodsName,
          oldSpecification: item.specification,
          oldModel: item.model,
          oldBrand: item.brand,
          oldRemark: '',
          safetyStockQuantityBef: 0,
          safetyStockQuantity: 0 // item.stockQuantity
        }]
        this.$store.dispatch('setrequirementGoodsList', list)
        this.$router.push({
          name: 'spareRequirementsAdd',
          query: {
            getList: '1'
          }
        })
      }
    },
    // 一件备用
    spareHandle () {
      let list = this.dataList.filter(item => {
        return item.choosed
      })
      if (this.activeTab === 'my') {
        let res = list.map(item => {
          return {
            oldGoodsCode: item.oldGoodsCode,
            oldGoodsName: item.oldGoodsName,
            oldSpecification: item.oldSpecification,
            oldModel: item.oldModel,
            oldBrand: item.oldBrand,
            oldRemark: item.oldRemark,
            goodsNum: 0,
            oldEdition: item.oldEdition,
            oldCongiguration: item.oldCongiguration,
            goodsPrice: item.price,
            // safetyStockQuantityBef: 0,
            safetyStockQuantity: item.stockQuantity,
            custspId: item.custspId
          }
        })
        this.$store.dispatch('setLclbDataList', res)
        this.$router.push({
          name: 'spareGetAdd',
          query: {
            getList: 1
          }
        })
      } else {
        let res = list.map(item => {
          return {
            oldGoodsCode: item.goodsCode,
            oldGoodsName: item.goodsName,
            oldSpecification: item.specification,
            oldModel: item.model,
            oldBrand: item.brand,
            oldRemark: '',
            safetyStockQuantityBef: 0,
            safetyStockQuantity: 0 // item.safetyStockQuantity
          }
        })
        this.$store.dispatch('setrequirementGoodsList', res)
        this.$router.push({
          name: 'spareRequirementsAdd',
          query: {
            getList: '1'
          }
        })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>
<style lang='scss' scoped>
.reserve {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px;
  .search-row {
    margin-bottom: 20px;
    display: flex;
    // justify-content: space-between;
    // border-bottom: 1px solid #eee;
    .search-sort {
      text-align: right;
    }
    .lclb_tabs {
      display: flex;
      font-size: 16px;
      .lclb_tab_item {
        text-align: center;
        width: 124px;
        line-height: 42px;
        background: #dddddd;
      }
      .tab_item_choosed {
        background: #0064c0;
        color: #fff;
      }
    }
  }
  .good_item {
    margin: 10px;
    line-height: 30px;
    font-size: 16px;
    position: relative;
    .item_img {
      height: 195px;
      width: 258px;
      border: 3px solid #fff;
      margin: 0 auto;
    }
    .item_img_choosed img {
      border: 3px solid rgba(68, 136, 249, 0.81);
    }
    .good_name {
      padding: 0 5px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    }
    .good_opt {
      padding: 0 5px;
      color: #666666;
      line-height: 40px;
      height: 40px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .good_item_choosed {
      color: #3d8bd4;
      font-size: 40px;
      font-weight: bold;
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 20;
      background-color: rgba(0, 0, 0, 0.1);
      .triangle {
        border-left: 100px solid transparent;
        border-right: 100px solid rgba(0, 0, 0, 0.1);
        border-bottom: 100px solid transparent;
        height: 0;
        width: 0;
        position: absolute;
        right: 0px;
        z-index: 2;
        .el-icon-check {
          position: absolute;
          right: -100px;
        }
      }
    }
  }
  .color_red {
    color: #ff3535;
  }
  .statistics {
    background: #f7f8fa;
    border: 2px solid #f7f8fa;
    line-height: 50px;
    padding: 0 20px;
    font-size: 16px;
    color: #333333;
  }
  .el-button {
    height: 28px;
    line-height: 0;
    background: #117dc9;
    color: #fff;
  }
}
</style>
